export default "__VITE_ASSET__CF__r3Qu__"